import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { user_img } from "../assets/imgs";

const CommonImagePopup = ({ img, setOpen }) => {
  return (
    <div className="img-popup-design-new">
      <div className="img-popup-new">
        <button className="img-popup-close" onClick={() => setOpen(null)}>
          <CloseIcon />
        </button>

        <img
          src={img || user_img}
          alt="Preview"
          style={{
            height: "400px",
            width: "400px",
            objectFit: "contain",
            borderRadius: "10px",
          }}
        />
      </div>
    </div>
  );
};

export default CommonImagePopup;
